export enum AuthState {
	loading,
	unauthenticated,
	authenticated,
	signingUp
}

export const ATTESTATION_TOKEN_LOCAL_KEY = 'attestationToken'
export const SIGN_IN_WITH_EMAIL_LOCAL_KEY = 'emailForSignIn'
